import { atom, selector } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "Yvooa-Core",
  storage: sessionStorage,
});

export const userData = atom({
  key: "userData",
  default: {},
  effects_UNSTABLE: [persistAtom],
});

export const isAuthenticated = selector({
  key: "isAuthenticated",
  get: ({ get }) => {
    const userInfo = get(userData);
    return Boolean(userInfo && userInfo.ID);
  },
});

export const accessToken = atom({
  key: "accessToken",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const idToken = atom({
  key: "idToken",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const refreshToken = atom({
  key: "refreshToken",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const profileImageUrl = atom({
  key: "profileImageUrl",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const clientId = atom({
  key: "clientId",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const companyId = atom({
  key: "companyId",
  default: "",
  effects_UNSTABLE: [persistAtom],
});
